// Overlay responsive de detalle: Modal centrado en desktop, bottom sheet
// nativo en móvil (vendedores de campo). Una sola fuente de verdad para el
// patrón. Soporta un estado de carga que muestra un Spin centrado en el body.
import type { ReactNode } from 'react';
import { Drawer, Grid, Modal, Spin } from 'antd';

interface DetalleOverlayProps {
  open: boolean;
  title: ReactNode;
  footer?: ReactNode;
  onClose: () => void;
  loading?: boolean;
  width?: number;
  children: ReactNode;
}

function SpinCentrado() {
  return (
    <div style={{ display: 'flex', justifyContent: 'center', padding: 48 }}>
      <Spin size="large" />
    </div>
  );
}

export function DetalleOverlay({
  open,
  title,
  footer,
  onClose,
  loading = false,
  width = 560,
  children,
}: DetalleOverlayProps) {
  const screens = Grid.useBreakpoint();
  const esMovil = !screens.lg;

  if (esMovil) {
    return (
      <Drawer
        open={open}
        onClose={onClose}
        placement="bottom"
        size="auto"
        title={title}
        footer={footer}
        destroyOnHidden
        styles={{
          section: { borderRadius: '16px 16px 0 0' },
          body: { maxHeight: '70vh', overflowY: 'auto' },
        }}
      >
        {loading ? <SpinCentrado /> : children}
      </Drawer>
    );
  }

  return (
    <Modal
      open={open}
      onCancel={onClose}
      title={title}
      footer={footer}
      centered
      width={width}
      destroyOnHidden
    >
      {loading ? <SpinCentrado /> : children}
    </Modal>
  );
}
